<header class="section-header">
  <h2>ویژگی‌های رفتاری</h2>
  <span lang="en">BEHAVIOR</span>
</header>
<dl class="metrics">
  <div class="metric-row" *ngFor="let metric of metrics">
    <dt>{{ metric.label }}</dt>
    <dd dir="ltr">{{ formatValue(context.summary, metric.field, metric.decimals, metric.unit) }}</dd>
  </div>
</dl>
